<script setup lang="ts">
import { cardKey } from "@/components/StickyNote/injectKeys";
import StickyStatus from "@/components/menu/StickyStatus/StickyStatus.vue";
import StatusDot from "@/components/ui/StatusDot.vue";
import { injectStrict } from "@/utils/vue";

import AttributeChip from "./AttributeChip.vue";

const card = injectStrict(cardKey);
</script>

<template>
  <AttributeChip name="status-chip" :tooltip="card.status?.name" active>
    <template #icon>
      <span class="status-dot">
        <StatusDot :status-class="card.status?.statusClass || 'undefined'" />
      </span>
    </template>
    <StickyStatus />
  </AttributeChip>
</template>

<style lang="scss" scoped>
.status-dot {
  height: 14px;
  width: 14px;
}
</style>
